import { createFileRoute, Outlet } from '@tanstack/react-router';
import { MessageSquare } from 'lucide-react';

export const Route = createFileRoute('/admin-console/platform-content/comms-and-content')({
    staticData: {
        permissions: ['admin_comms:read'],
        breadcrumb: {
            title: 'Comms & Content',
            inactive: true,
        },
        ui: {
            icon: MessageSquare,
            menuDescription: 'Templates, app text, and FAQ',
        },
    },
    component: Outlet,
});
